import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserContext } from '@/contexts/UserContext';
import { useCurrentUser } from '@/hooks/useCurrentUser';

export function useAdminGreeting(): string {
  const { t } = useTranslation();
  const { demoUser } = useUserContext();
  const currentUser = useCurrentUser();

  const displayName = currentUser?.displayName ?? demoUser.nombre;

  return useMemo(() => {
    const h = new Date().getHours();
    const key =
      h < 12 ? 'admin.greetingMorning'
      : h < 18 ? 'admin.greetingAfternoon'
      :           'admin.greetingEvening';
    return displayName ? `${t(key)}, ${displayName}` : t(key);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, displayName]);
}
